import store from '@/store'
import _ from 'lodash'
import clientModelMock from '../../../fakeserver/data/page'

function loadClientModel() {
  const path = 'OIE.storevuedata'
  const clientModel = _.get(window, 'OIE.storevuedata')
  if(process.env.VUE_APP_TYPE === 'mvc' && !clientModel) {
    throw new Error(`Client model not found on window.${path}`)
  } else if (process.env.VUE_APP_TYPE === 'spa') {
    const initialMockSpaModel = clientModelMock.getCurrentPageData(window.location.pathname)
    store.dispatch('setCurrentPageData', initialMockSpaModel)
    return initialMockSpaModel
  } else {
    store.dispatch('setCurrentPageData', clientModel)
  }
  return clientModel
}

export { loadClientModel }
